import { render, staticRenderFns } from "./data_statistics_list.vue?vue&type=template&id=e4f0a5a4&scoped=true&"
import script from "./data_statistics_list.vue?vue&type=script&lang=js&"
export * from "./data_statistics_list.vue?vue&type=script&lang=js&"
import style0 from "./data_statistics_list.vue?vue&type=style&index=0&id=e4f0a5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0a5a4",
  null
  
)

export default component.exports